import React from "react";

import { Link, useLocation } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useTranslation } from "react-i18next";
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Layout = ({ children, user }) => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(1);
  const location = useLocation();
  const flushTop = location.pathname === "/profile" || location.pathname.startsWith("/activeevent") || location.pathname.startsWith("/dealbreakers");


  React.useEffect(() => {
    const path = location.pathname;
    let val = 0;
    if (path === "/" || path.startsWith("/activeevent")) {
      val = 1;
    } else if (path === "/profile" || path.startsWith("/matchprofile")) {
      val = 2;
    } else if (path === "/events") {
      val = 0;
    }
    setValue(val);
  }, [location.pathname]);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100dvh", boxSizing: "border-box", overflow: "hidden", paddingTop: flushTop ? 0 : 20 }}>
      <main style={{ flex: 1, minHeight: 0, overflowY: "auto", WebkitOverflowScrolling: "touch", scrollPaddingBottom: 250 }}>
        {children}
      </main >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        style={{position:'fixed', bottom:0, width:'100%', borderTop: '1px solid lightgrey', boxShadow: '0px -1px 9px lightgrey'}}
      >
        <BottomNavigationAction label={t('nav.home.button')} icon={<HomeIcon />} component={Link} to="/events"/>
        <BottomNavigationAction label={t('nav.myevents.button')} icon={<EventIcon />} component={Link} to="/"/>
        <BottomNavigationAction label={t('nav.profile.button')} icon={<AccountCircleIcon />} component={Link} to="/profile"/>
      </BottomNavigation>
    </div>
  );
};

export default Layout;
